import { useMutation } from "@tanstack/react-query";
import { danger } from "@";
import { exportNationalCenterReport } from "./api";

export const useExportNationalCenterReportMutation = () => {
  return useMutation({
    mutationFn: exportNationalCenterReport,
    onError: () => {
      danger("خطأ تصدير البيانات");
    },
  });
};
